export const NURSE_NOTE_TYPE = 'Nurse Note';
export const PROVIDER_NOTE_TYPE = 'Provider Note';
export const SYMPTOM_ANALYSIS_TYPE = 'Symptom Analysis';
export const SYSTEM_ASSESSMENT_TYPE = 'System Assessment';



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/progressNoteTypes.js